'use client';

import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
// import { CheckIcon } from 'lucide-react';
import CheckIcon from '@/assets/icons/Checkbox/CheckIcon.svg?react';

import { cn } from '@/utils/tailwind';

function Checkbox({ className, ...props }: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        'focus-visible:border-ring bg-white focus-visible:border-gr-900/50 data-[state=checked]:text-white',
        'aria-invalid:ring-destructive/20  aria-invalid:border-destructive peer',
        'h-[16px] w-[16px] shrink-0 rounded-[2px] border border-gr-400 outline-none transition-shadow',
        'focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50',
        'data-[state=checked]:border-point-500 data-[state=checked]:bg-point-500',
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="flex items-center justify-center text-current transition-none"
      >
        <CheckIcon />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox };
